export const ADD_BUILDING_REQUEST = 'ADD_BUILDING_REQUEST'
export const ADD_BUILDING_RESET = 'ADD_BUILDING_RESET'
export const ADD_BUILDING_SUCCESS = 'ADD_BUILDING_SUCCESS'
export const ADD_BUILDING_ERROR = 'ADD_BUILDING_ERROR'
export const ADD_BUILDING_VALIDATION_ERROR = 'ADD_BUILDING_VALIDATION_ERROR'
